/* ═══════════════════════════════════════════════════════════════════════════
   DN5 · wheel popup behaviour.
   🔴 Prizes, slice count, weights, copy and colours are all read from the JSON emitted by Liquid; **nothing is hard-coded in JS**.
      Configured in Theme editor → Popup & chat (section settings and prize blocks).
   🔴 Support ticket submission uses the shared engine dn-ticket.js; this file does not touch it.
   Only one global name is taken: window.DN5Wheel.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.DN5Wheel) return;
  var D = document;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function jsonOf(sel) { var el = $(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  var root = $('[data-dn5w]');
  var PRIZES = jsonOf('[data-dn5w-prizes]') || [];
  var COPY = jsonOf('[data-dn5w-strings]') || {};
  var KEY = 'dn5w_seen_until';
  var WON = 'dn5w_won';
  var UNLOCKED = 'dn5w_unlocked';
  var ATTEMPT = 'dn5w_pending_attempt';
  var ATTEMPT_TTL_MS = 10 * 60 * 1000;
  function isChallengePage() {
    return /(?:^|\/)challenge\/?$/i.test(window.location.pathname);
  }
  function readAttempt(form, consume) {
    try {
      var raw = sessionStorage.getItem(ATTEMPT);
      if (!raw) return false;
      var saved = JSON.parse(raw);
      var age = Date.now() - Number(saved.at);
      var valid = saved.formId === 'dn5w-newsletter' &&
        (!consume || (form && form.id === saved.formId)) &&
        Number.isFinite(age) && age >= 0 && age <= ATTEMPT_TTL_MS;
      if (consume || !valid) sessionStorage.removeItem(ATTEMPT);
      return valid;
    } catch (e) {
      try { sessionStorage.removeItem(ATTEMPT); } catch (er) {}
      return false;
    }
  }
  function canPlay() {
    try { return !!localStorage.getItem(UNLOCKED); } catch (e) { return false; }
  }
  var pendingOpen = false;
  var privacyTimer = null;
  var privacyLoadRequested = false;
  function visible(el) { return !!(el && el.getBoundingClientRect().width && el.getBoundingClientRect().height); }
  function privacyClear() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.shouldShowBanner !== 'function') return false;
    try { if (privacy.shouldShowBanner() !== false) return false; } catch (e) { return false; }
    return !visible($('#shopify-pc__banner')) && !visible($('#shopify-pc__prefs'));
  }
  function requestOpen() {
    if (isChallengePage()) return;
    pendingOpen = true;
    if (!privacyClear()) {
      if (!privacyLoadRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        privacyLoadRequested = true;
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { if (pendingOpen) requestOpen(); }); } catch (e) {}
      }
      if (!privacyTimer) privacyTimer = setTimeout(function retry() {
        privacyTimer = null;
        if (pendingOpen) requestOpen();
      }, 500);
      return;
    }
    pendingOpen = false;
    open();
  }

  /* ── open / close ──────────────────────────────────────────────────────── */
  function open() {
    if (!root) return;
    root.hidden = false;
    /* Tell other scripts (the announcement carousel's DNMotionLifecycle, the two dn3 scripts) that "a popup is covering";
       they look for .is-open on [data-dn-pop] — contract in SHELL-CONTRACT.md §8
       🔴 **Do not defer this with requestAnimationFrame**: rAF never fires while the tab is in the background,
          so a shopper who switches away and back finds the popup never appeared (measured 2026-10-17 at 390:
          root stuck at display:none, with is-unlocked but no is-open).
          The entrance animation is a CSS animation on .dn5w__card; no frame needs to render first. */
    root.classList.add('is-open');
    D.body.classList.add('no-scroll');
  }
  function close() {
    if (!root) return;
    pendingOpen = false;
    root.classList.remove('is-open');
    root.hidden = true;
    D.body.classList.remove('no-scroll');
    remember();
  }
  function remember() {
    var days = parseInt(root.getAttribute('data-days') || '14', 10);
    try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {}
  }
  function suppressed() {
    try {
      var until = parseInt(localStorage.getItem(KEY) || '0', 10);
      return until && Date.now() < until;
    } catch (e) { return false; }
  }

  /* ── steps ─────────────────────────────────────────────────────────────── */
  function step(name) {
    if (name === 'play' && readWon()) name = 'won';
    $$('[data-dn5w-step]', root).forEach(function (s) {
      s.hidden = s.getAttribute('data-dn5w-step') !== name;
    });
    var spin = $('[data-dn5w-spin]', root), lock = $('[data-dn5w-hublock]', root);
    var playable = name === 'play';
    var available = !playable || window.dn.prize.pick(PRIZES) >= 0;
    if (spin) { spin.hidden = !playable || !available; spin.disabled = !available; }
    if (lock) lock.hidden = playable && available;
    if (playable && !available) {
      var unavailableHint = $('[data-dn5w-hint]', root);
      if (unavailableHint) unavailableHint.textContent = COPY.noPrizes || '';
    }
    root.classList.toggle('is-unlocked', name !== 'email');
  }

  var spinning = false;
  function readWon() {
    try {
      var raw = localStorage.getItem(WON);
      if (!raw) return null;
      try {
        var saved = JSON.parse(raw);
        if (saved && typeof saved === 'object' && Number.isInteger(saved.i)) {
          var matched = PRIZES.findIndex(function (p) { return saved.code && p.code === saved.code; });
          if (matched >= 0) saved.i = matched;
          else if (!PRIZES[saved.i] || (saved.code && PRIZES[saved.i].code !== saved.code)) saved.i = -1;
          return saved;
        }
      } catch (e) {}
      var index = PRIZES.findIndex(function (p) { return p.code && p.code === raw; });
      return { i: index, code: raw };
    } catch (e) { return null; }
  }
  function showWon(saved) {
    var p = PRIZES[saved.i] || {};
    step('won');
    var lab = $('[data-dn5w-prizelabel]', root), sub = $('[data-dn5w-prizesub]', root), code = $('[data-dn5w-code]', root);
    if (lab) lab.textContent = saved.label || p.label || '';
    if (sub) sub.textContent = saved.sub || p.sub || '';
    if (code) code.textContent = saved.code || p.code || '';
  }
  function spin() {
    if (spinning || !PRIZES.length || readWon() || !canPlay() || !$('[data-dn5w-step="play"]:not([hidden])', root)) return;
    var face = $('[data-dn5w-face]', root);
    var segDeg = parseFloat(root.getAttribute('data-seg')) || (360 / PRIZES.length);
    var i = window.dn.prize.pick(PRIZES);
    if (i < 0 || !PRIZES[i]) { step('play'); return; }
    spinning = true;
    var cur = parseFloat(face.getAttribute('data-rot') || '0');
    /* land slice i under the pointer at the top: same formula as proto line 161 */
    var target = cur + 360 * 5 + ((360 - i * segDeg) - (cur % 360) + 360) % 360;
    face.setAttribute('data-rot', String(target));
    face.style.transform = 'rotate(' + target + 'deg)';
    var hint = $('[data-dn5w-hint]', root);
    if (hint && COPY.spinning) hint.textContent = COPY.spinning;
    setTimeout(function () { award(i); }, 3700);
  }

  /* ── prize won ─────────────────────────────────────────────────────────── */
  function award(i) {
    var p = PRIZES[i];
    if (!p || readWon()) return;
    var saved = { i: i, code: p.code || '', label: p.label || '', sub: p.sub || '' };
    try { localStorage.setItem(WON, JSON.stringify(saved)); } catch (e) {}
    showWon(saved);

    var box = $('[data-dn5w-status]', root);
    if (!box) return;
    box.innerHTML = '';
    window.dn.prize.award(p, box, COPY, root.getAttribute('data-auto-code') === 'true');
  }

  /* ── wiring ────────────────────────────────────────────────────────────── */
  function boot() {
    /* Shopify can render this global section on its native CAPTCHA interstitial.
       Keep only a still-valid submission marker there; wait for the actual return page. */
    if (isChallengePage()) {
      readAttempt(null, false);
      if (root) { root.hidden = true; root.classList.remove('is-open'); }
      return;
    }
    /* the side tab can always open it manually (even if this round was already seen) */
    D.addEventListener('click', function (e) {
      if (e.target.closest('[data-dn5w-open]')) { e.preventDefault(); step(readWon() ? 'won' : (canPlay() ? 'play' : 'email')); requestOpen(); return; }
      if (!root) return;
      if (e.target.closest('[data-dn5w-close]') || e.target.classList.contains('dn5w__overlay')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-dn5w-spin]')) { e.preventDefault(); spin(); return; }
      var copyBtn = e.target.closest('[data-dn5w-copy]');
      if (copyBtn) {
        e.preventDefault();
        var val = ($('[data-dn5w-code]', root) || {}).textContent || '';
        var done = function () {
          var l = $('[data-dn5w-copylabel]', root);
          if (!l) return;
          l.textContent = COPY.copied || 'COPIED';
          setTimeout(function () { l.textContent = COPY.copy || 'TAP TO COPY'; }, 1800);
        };
        var failed = function () {
          var l = $('[data-dn5w-copylabel]', root);
          if (l) l.textContent = COPY.copyFailed || COPY.copy || '';
          var codeText = $('[data-dn5w-code]', root);
          try { if (codeText && window.getSelection) { var selection = window.getSelection(); selection.removeAllRanges(); var range = D.createRange(); range.selectNodeContents(codeText); selection.addRange(range); } } catch (e) {}
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(val).then(done, failed);
        else failed();
      }
    });
    if (!root) return;
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    D.addEventListener('visitorConsentCollected', function () { if (pendingOpen) requestOpen(); });

    /* The server marker is also rendered for a bare success query. Correlate it with a recent
       submit from this tab's native form; never store the email or unlock before return. */
    var form = $('.dn5w__form', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        var input = $('[data-dn5w-email]', root);
        var ok = input && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
        if (!ok) {
          e.preventDefault();
          try { sessionStorage.removeItem(ATTEMPT); } catch (er) {}
          root.classList.add('has-err');
          var err = $('[data-dn5w-err]', root);
          if (err) err.hidden = false;
          return;
        }
        root.classList.remove('has-err');
        try { sessionStorage.setItem(ATTEMPT, JSON.stringify({ formId: form.id, at: Date.now() })); } catch (er) {}
      });
      var email = $('[data-dn5w-email]', root);
      if (email) email.addEventListener('input', function () {
        root.classList.remove('has-err');
        var err = $('[data-dn5w-err]', root);
        if (err) err.hidden = true;
      });
    }

    var pendingAttempt = readAttempt(form, true); /* consumed on the real return page, including failures */
    var posted = !!(pendingAttempt && $('[data-dn5w-posted]', form));
    if (posted) { try { localStorage.setItem(UNLOCKED, '1'); } catch (e) {} }
    var alreadyWon = readWon();
    step(alreadyWon ? 'won' : (canPlay() ? 'play' : 'email'));
    if (alreadyWon) {
      showWon(alreadyWon);
    }

    if (suppressed() && !posted) return;          /* inside the frequency cap it does not auto-open, but the side tab can still open it */

    if (posted) { requestOpen(); return; }
    var delay = parseInt(root.getAttribute('data-delay') || '8', 10);
    setTimeout(function () { if (!root.classList.contains('is-open')) requestOpen(); }, Math.max(0, delay) * 1000);

    if (root.getAttribute('data-exit') === 'true') {
      D.addEventListener('mouseout', function onOut(e) {
        if (e.clientY > 0 || e.relatedTarget) return;
        D.removeEventListener('mouseout', onOut);
        if (!root.classList.contains('is-open')) requestOpen();
      });
    }
  }

  window.DN5Wheel = { open: requestOpen, close: close, boot: boot };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
